import React from "react";
import PropTypes from "prop-types";
import "./EmailMismatchModal.css";

const EmailMismatchModal = ({
  show,
  loggedInEmail,
  invitedEmail,
  onSignOut,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <div className="email-mismatch-overlay" id="email-mismatch-modal-overlay">
      <div className="email-mismatch-dialog" role="dialog" aria-modal="true">
        <div className="email-mismatch-header">
          <h3 className="email-mismatch-title">Email Mismatch Notice</h3>
        </div>
        <div className="email-mismatch-body">
          <p className="email-mismatch-text">
            You are currently signed in as <strong>{loggedInEmail}</strong>.
          </p>
          <p className="email-mismatch-text">
            This invitation was sent to <strong>{invitedEmail}</strong>.
          </p>
          <p className="email-mismatch-subtext">
            Would you like to sign out of your current account to continue with the invitation?
          </p>
        </div>
        <div className="email-mismatch-actions">
          <button
            type="button"
            className="email-mismatch-btn email-mismatch-btn-cancel"
            onClick={onCancel}
            id="mismatch-cancel-btn"
          >
            Cancel
          </button>
          <button
            type="button"
            className="email-mismatch-btn email-mismatch-btn-signout"
            onClick={onSignOut}
            id="mismatch-signout-btn"
          >
            Sign Out & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

EmailMismatchModal.propTypes = {
  show: PropTypes.bool.isRequired,
  loggedInEmail: PropTypes.string,
  invitedEmail: PropTypes.string,
  onSignOut: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EmailMismatchModal;
